import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { useHapticFeedback } from '../native';
export const Switch = ({ checked, className, onCheckedChange, disabled = false, size = 'm', }) => {
    const haptics = useHapticFeedback();
    return (_jsx(Root, { "$disabled": disabled, "$size": size, className: className, "data-checked": checked, onClick: () => {
            if (!disabled && onCheckedChange) {
                haptics.impactOccurred('light');
                onCheckedChange(!checked);
            }
        }, children: _jsx(Thumb, { "$disabled": disabled, "$size": size }) }));
};
// TODO: Use css vars and data-size
const SIZE_MAP = {
    s: {
        height: '17px',
        width: '30px',
        checkedPadding: '2.5px',
        uncheckedPadding: '3.5px',
        thumb: {
            default: { height: '10px', width: '10px' },
            checked: { height: '12px', width: '12px', translateX: '12.5px' },
        },
    },
    m: {
        height: '24px',
        width: '42px',
        checkedPadding: '3px',
        uncheckedPadding: '5px',
        thumb: {
            default: { height: '14px', width: '14px' },
            checked: { height: '18px', width: '18px', translateX: '18px' },
        },
    },
};
const Root = styled.div `
  display: inline-flex;
  justify-items: start;
  transition: all 0.15s linear;
  border-radius: 12px;

  ${({ $size }) => {
    const size = SIZE_MAP[$size];
    return css `
      height: ${size.height};
      width: ${size.width};
      padding: ${size.uncheckedPadding};
    `;
}}

  ${({ $disabled, $size }) => {
    const size = SIZE_MAP[$size];
    if ($disabled) {
        return css `
        background: var(--backgroundA-2);
        padding: ${size.uncheckedPadding};

        &[data-checked='true'] {
          padding: ${size.checkedPadding};
        }
      `;
    }
    return css `
      background: var(--backgroundA-5);
      padding: ${size.uncheckedPadding};
      cursor: pointer;

      &[data-checked='true'] {
        background: var(--success-9);
        padding: ${size.checkedPadding};
      }
    `;
}}
`;
const Thumb = styled.div `
  background: ${({ $disabled }) => $disabled ? 'var(--backgroundA-2)' : '#FFF'};

  transition: all 0.15s linear;
  border-radius: 50%;

  ${({ $size }) => {
    const { default: d, checked: c } = SIZE_MAP[$size].thumb;
    return css `
      height: ${d.height};
      width: ${d.width};

      ${Root}[data-checked="true"] & {
        transform: translateX(${c.translateX});
        height: ${c.height};
        width: ${c.width};
      }
    `;
}}
`;
//# sourceMappingURL=switch.js.map